import { CurrencyPipe, DatePipe, NgOptimizedImage } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core'
import { Event } from '../../../domain/Event'
import { CurrencyUnitPipe } from '../../../pipes/currency-unit.pipe'
import { richTextPlainText, truncateRichTextHtml } from '../../../utilities/rich-text'
import { environment } from '../../../../environments/environment'
import { QuillModule } from 'ngx-quill'

@Component({
    selector: 'app-venue-storefront-event-card',
    standalone: true,
    imports: [CurrencyUnitPipe, DatePipe, NgOptimizedImage, QuillModule],
    providers: [CurrencyPipe],
    templateUrl: './venue-storefront-event-card.component.html',
    styleUrls: ['./venue-storefront-event-card.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VenueStorefrontEventCardComponent {
    private readonly descriptionCharacterLimit = 200

    event = input.required<Event>()
    nextDateTime = input.required<Date>()
    currencyCode = input<string | null>(null)
    learnMore = output<void>()

    protected imageUrl = computed(() => {
        const imageId = this.event().imageId
        return imageId
            ? `${environment.cdnUrl}/700x400/event-images/${imageId}`
            : null
    })
    protected description = computed(() => {
        const description = this.event().description
        return richTextPlainText(description)
            ? truncateRichTextHtml(description, this.descriptionCharacterLimit)
            : null
    })
    protected startDateTime = computed(() => {
        return this.event().recurrence.startTime ? this.nextDateTime() : null
    })
    protected endDateTime = computed(() => {
        return this.event().recurrence.endTime?.dateTimeOnDate(this.nextDateTime()) ?? null
    })
    protected hasCharges = computed(() => {
        const event = this.event()
        return [
            event.depositAmount,
            event.depositFlatFeeAmount,
            event.cancellationChargeAmount,
            event.cancellationChargePartyAmount,
        ].some(amount => (amount ?? 0) > 0)
    })
}
